var map = {
	"./30tip.png": 85750,
	"./BIGTON.png": 92775,
	"./TONwallet.png": 1280,
	"./activity-top.png": 81522,
	"./airdrop-big.png": 86780,
	"./airdrop-channel.png": 85745,
	"./airdrop-freemint.png": 44746,
	"./airdrop-icons.png": 92227,
	"./airdrop-ok.png": 2664,
	"./airdrop-pass.png": 64079,
	"./airdrop-tap-icon1.png": 65994,
	"./airdrop-tap-icon2.png": 43121,
	"./airdrop-tap-icon3.png": 57056,
	"./airdrop-tap-icon4.png": 86026,
	"./airdrop-tap-icon5.png": 48587,
	"./airdrop-tap-icon6.png": 75609,
	"./airdrop-tap-r2-icon1.png": 85316,
	"./airdrop-tap-r2-icon10.png": 96393,
	"./airdrop-tap-r2-icon2.png": 50368,
	"./airdrop-tap-r2-icon3.png": 7814,
	"./airdrop-tap-r2-icon4.png": 69763,
	"./airdrop-tap-r2-icon5.png": 77241,
	"./airdrop-tap-r2-icon6.png": 84846,
	"./airdrop-tap-r2-icon7.png": 94372,
	"./airdrop-tap-r2-icon8.png": 97645,
	"./airdrop-tap-r2-icon9.png": 24860,
	"./airdrop-tickets.png": 74318,
	"./airdrop-top-bg.png": 59515,
	"./airdrop-wallet.png": 70284,
	"./airdrop.png": 73971,
	"./award.png": 78171,
	"./bnb_logo.png": 62243,
	"./boost-list-icon-1.png": 15035,
	"./boost-list-icon-2.png": 72043,
	"./boost-list-icon-3.png": 43444,
	"./boost-list-icon-4.png": 4681,
	"./boost-list-icon-5.png": 67241,
	"./boost-list-icon-6.png": 2970,
	"./browser.png": 22461,
	"./btn-icon-boost.png": 97498,
	"./btn-icon-frens.png": 39246,
	"./code-icon-0.png": 2913,
	"./daily-invite.png": 49729,
	"./daily_icon.png": 29094,
	"./diamond.png": 97669,
	"./earn-head-icon-gift.png": 59216,
	"./earn-icon-0.png": 43847,
	"./earn-key.png": 50899,
	"./earn-list-icon-1.png": 349,
	"./earn-list-icon-2.png": 45090,
	"./earn-list-icon-gift.png": 95596,
	"./earn-logo.png": 44577,
	"./finish.png": 26059,
	"./frens-1.png": 44604,
	"./frens-2.png": 32854,
	"./frens-3.png": 28306,
	"./game/fruitRush/1.png": 34337,
	"./game/fruitRush/2.png": 17306,
	"./game/fruitRush/3.png": 74949,
	"./game/fruitRush/4.png": 43352,
	"./game/fruitRush/5.png": 98644,
	"./game/fruitRush/6.png": 4334,
	"./game/fruitRush/7.png": 75172,
	"./game/fruitRush/bg.png": 62762,
	"./game/poptop.png": 1644,
	"./game/sheep/1.png": 18067,
	"./game/sheep/2.png": 96866,
	"./game/sheep/3.png": 67476,
	"./game/sheep/4.png": 2845,
	"./game/sheep/5.png": 77326,
	"./game/sheep/6.png": 5203,
	"./game/sheep/7.png": 99219,
	"./game/sheep/8.png": 31344,
	"./game/sheep/9.png": 28247,
	"./icon-frens.png": 93011,
	"./icon-pph-1.png": 37825,
	"./icon-pph-2.png": 42220,
	"./index-btn-activity.png": 76101,
	"./index-btn-airdrop.png": 21553,
	"./index-btn-appcenter.png": 22110,
	"./index-btn-boost.png": 30586,
	"./index-btn-earn.png": 3263,
	"./index-btn-frens.png": 94744,
	"./index-btn-home.png": 20638,
	"./index-btn-icon-1.png": 36013,
	"./index-btn-icon-2.png": 7031,
	"./index-btn-icon-21.png": 12586,
	"./index-btn-icon-3.png": 64551,
	"./index-btn-icon-4.png": 66708,
	"./index-btn-lottery.png": 95357,
	"./index-btn-mine.png": 6368,
	"./index-btn-wallet.png": 46198,
	"./index-c-btn-bg.png": 80124,
	"./index-icon-big-coin.png": 57569,
	"./index-icon-bronze.png": 45580,
	"./index-icon-energy.png": 58052,
	"./index-icon-level.png": 75009,
	"./index-icon-pph.png": 76938,
	"./index-icon-small-coin.png": 68841,
	"./index-icon-squad-1.png": 98556,
	"./index-icon-squad.png": 21273,
	"./index-icon-wallet.png": 82472,
	"./join-icon-frens.png": 25786,
	"./level/Bronze.png": 81649,
	"./level/Diamond.png": 17308,
	"./level/Emerald.png": 39975,
	"./level/Gold.png": 88027,
	"./level/Platinum.png": 96604,
	"./level/Ruby.png": 29676,
	"./level/Silver.png": 97004,
	"./level/Wish.png": 85792,
	"./lock.png": 72193,
	"./logo.png": 94623,
	"./lottery-icon.png": 55375,
	"./luckcode.png": 49349,
	"./lucky/gift-bg.png": 46974,
	"./lucky/icon-star.png": 36281,
	"./lucky/icon-star2.png": 16558,
	"./lucky/key.png": 64765,
	"./lucky/light1-gift.png": 6530,
	"./lucky/light1.png": 94421,
	"./lucky/light2-gift.png": 88083,
	"./lucky/light2.png": 73133,
	"./lucky/lucky-btn-bg.png": 2548,
	"./lucky/lucky-btn2.png": 50982,
	"./lucky/lucky-item-bg-gift.png": 73161,
	"./lucky/lucky-item-bg.png": 48012,
	"./lucky/lucky-result-coin-tap.png": 55788,
	"./lucky/lucky-result-coin-tapcoins.png": 16414,
	"./lucky/lucky-result-coin-tapstock.png": 43375,
	"./lucky/lucky-result-coin-ton.png": 82649,
	"./lucky/lucky-result-coin-usdt.png": 11104,
	"./lucky/lucky-result-light.png": 60268,
	"./lucky/tap.png": 35092,
	"./lucky/tapcoins.png": 78565,
	"./lucky/tapgiftshard.png": 31965,
	"./lucky/ton.png": 52808,
	"./lucky/usdt.png": 5976,
	"./luckybox/bought-bg.png": 77765,
	"./luckybox/box/1.png": 74891,
	"./luckybox/box/11.png": 30398,
	"./luckybox/box/2.png": 59330,
	"./luckybox/box/21.png": 87336,
	"./luckybox/box/3.png": 11363,
	"./luckybox/box/31.png": 16370,
	"./luckybox/box/4.png": 1188,
	"./luckybox/box/41.png": 85447,
	"./luckybox/box/5.png": 92037,
	"./luckybox/box/51.png": 51508,
	"./luckybox/box/6.png": 21910,
	"./luckybox/box/61.png": 90135,
	"./luckybox/leaderboard.png": 32395,
	"./luckybox/luckybox-hd.png": 76390,
	"./luckybox/luckybox-hd1.png": 81015,
	"./luckybox/luckybox-item-bg.png": 39889,
	"./luckybox/records.png": 2017,
	"./menu-bg.png": 5620,
	"./new/30tip.png": 10411,
	"./new/CRY.png": 61764,
	"./new/TAP-small.png": 24460,
	"./new/TAP.png": 63297,
	"./new/TAPCOINS-small.png": 9474,
	"./new/TAPCOINS.png": 12129,
	"./new/TAPSTOCK-small.png": 12337,
	"./new/TAPSTOCK.png": 68715,
	"./new/TON.png": 5418,
	"./new/USDT-small.png": 4943,
	"./new/USDT.png": 56595,
	"./new/avatar/avatar-1.png": 24774,
	"./new/avatar/avatar-2.png": 93337,
	"./new/avatar/avatar-3.png": 2025,
	"./new/avatar/avatar-4.png": 28018,
	"./new/avatar/avatar-5.png": 25571,
	"./new/blind/bind-box.png": 16670,
	"./new/blind/bind-select.png": 31329,
	"./new/blind/blind-container-bg.png": 65899,
	"./new/blind/blind-items-board.png": 29146,
	"./new/blind/reward-box.png": 39264,
	"./new/blind/reward-select.png": 6608,
	"./new/fortune/fortune-card-Bgblack.png": 99231,
	"./new/fortune/fortune-card-Bgblue.png": 8874,
	"./new/fortune/fortune-card-Bggreen.png": 6509,
	"./new/fortune/fortune-card-Bgorange.png": 61242,
	"./new/fortune/fortune-card-Bgpink.png": 62714,
	"./new/fortune/fortune-card-Bgred.png": 72867,
	"./new/fortune/fortune-card-Bgyellow.png": 78053,
	"./new/fortune/fortune-card-light.png": 53154,
	"./new/fortune/fortune-card.png": 35108,
	"./new/fortune/forturn-star.png": 97267,
	"./new/fortune/forturn-tag.png": 87539,
	"./new/fortune/orturn-synthesis-empty.png": 85965,
	"./new/game-small.png": 76050,
	"./new/gift-selector-997.png": 94592,
	"./new/gift-selector-arrow-997.png": 17144,
	"./new/gift-selector-arrow.png": 53981,
	"./new/gift-selector.png": 21226,
	"./new/gift/gift-exclusise-img.png": 89505,
	"./new/gift/gift-high-img.png": 11073,
	"./new/hot.png": 3785,
	"./new/icon-diamond.png": 93365,
	"./new/icon-gold-1.png": 22444,
	"./new/icon-group.png": 76515,
	"./new/icon-menu.png": 70354,
	"./new/icon-ok.png": 37674,
	"./new/icon-people.png": 74432,
	"./new/icon-profit.png": 67918,
	"./new/icon-ranking.png": 98853,
	"./new/icon-wallet.png": 16864,
	"./new/index-bg-gold.png": 33292,
	"./new/index-icon-boosts.png": 38663,
	"./new/index-icon-crypto.png": 91607,
	"./new/index-icon-frens.png": 67993,
	"./new/index-icon-progress.png": 59021,
	"./new/index-icon-slots.png": 4282,
	"./new/index-icon-spin.png": 50241,
	"./new/lock/avatar-lock-l.png": 76149,
	"./new/lock/avatar-lock-s.png": 5386,
	"./new/lock/double_p.png": 45844,
	"./new/lock/gift-1.png": 43010,
	"./new/lock/gift-2.png": 69894,
	"./new/lock/gift-3.png": 37356,
	"./new/machine/machine-arrow.png": 17336,
	"./new/machine/machine-bg.png": 5455,
	"./new/machine/machine-btn1-bg-1.png": 29058,
	"./new/machine/machine-btn1-bg.png": 87662,
	"./new/machine/machine-btn2-bg-1.png": 73990,
	"./new/machine/machine-btn2-bg.png": 60726,
	"./new/machine/machine-main-bg.png": 92956,
	"./new/machine/machine-title.png": 39551,
	"./new/menu-active-bg.png": 36962,
	"./new/menu-airdrop-active.png": 84387,
	"./new/menu-airdrop.png": 19842,
	"./new/menu-app-active.png": 2627,
	"./new/menu-app.png": 93024,
	"./new/menu-bg.png": 48030,
	"./new/menu-earn-active.png": 35656,
	"./new/menu-earn.png": 78194,
	"./new/menu-game-active.png": 57508,
	"./new/menu-game.png": 31929,
	"./new/menu-gift-active.png": 10321,
	"./new/menu-gift.png": 47003,
	"./new/menu-home-active.png": 11681,
	"./new/menu-home.png": 30399,
	"./new/menu-nft-active.png": 4654,
	"./new/menu-nft.png": 86814,
	"./new/menu-study-active.png": 63565,
	"./new/menu-study.png": 53568,
	"./new/menu-tasks-active.png": 27283,
	"./new/menu-tasks.png": 23570,
	"./new/mpay-logo.png": 34077,
	"./new/mpayBanner__title.png": 70369,
	"./new/nav-icon-achievements.png": 96289,
	"./new/nav-icon-bounty.png": 18689,
	"./new/nav-icon-code.png": 4169,
	"./new/nav-icon-login.png": 82097,
	"./new/new.png": 76794,
	"./new/nftInfo/nftInfo-items-bg.png": 8757,
	"./new/niceLucky/btn-1.png": 70699,
	"./new/niceLucky/btn-2.png": 72564,
	"./new/niceLucky/icon-buy.png": 77947,
	"./new/niceLucky/icon-invite.png": 15850,
	"./new/niceLucky/icon-shard.png": 82170,
	"./new/niceLucky/icon-ship.png": 54684,
	"./new/niceLucky/icon-task.png": 53731,
	"./new/niceLucky/light.png": 22540,
	"./new/niceLucky/niceLucky-bottom.png": 52706,
	"./new/niceLucky/niceLucky-item-active-bg.png": 26666,
	"./new/niceLucky/niceLucky-item-bg.png": 53468,
	"./new/niceLucky/niceLucky.png": 13243,
	"./new/niceLucky/niceLucky_title.png": 2036,
	"./new/niceLucky/ship-num.png": 42450,
	"./new/perHour.png": 88043,
	"./okwallet-logo.png": 36863,
	"./okxwallet-live.png": 52338,
	"./okxwallet-top.png": 19501,
	"./pop-award-icon-0.png": 79986,
	"./pop-coin-hero-icon-0.png": 63230,
	"./pop-up-gold-icon-0.png": 9611,
	"./premium-s.png": 93685,
	"./premium.png": 69018,
	"./rank-1.png": 19162,
	"./rank-2.png": 32030,
	"./rank-3.png": 78368,
	"./rank-bronze.png": 44222,
	"./sd.png": 18773,
	"./sign-calendar-ok.png": 36468,
	"./sign-calendar.png": 18976,
	"./sign-premium.png": 96936,
	"./solojack-tip.png": 57211,
	"./squad-icon-1.png": 54583,
	"./squad-icon-2.png": 44481,
	"./squad-icon-3.png": 3355,
	"./squad-icon-4.png": 83051,
	"./start.png": 8059,
	"./tap.png": 30909,
	"./task-detail-arrow.png": 50056,
	"./task-detail-arrow2.png": 88161,
	"./tickets.png": 73780,
	"./time.png": 92661,
	"./tip.png": 62136,
	"./ton-add.png": 5929,
	"./ton-stars-fill.png": 31493,
	"./ton-stars.png": 92550,
	"./tron.png": 89486,
	"./turbo.png": 11278,
	"./unknown.png": 70001,
	"./up.png": 570,
	"./usdt-p.png": 65984,
	"./usdt.png": 44777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31029;